import { GradientValueType, ImageValueType, safeParseBackground } from '@vedalib/editor'
import { setThemeVariable } from '@vedalib/editor/lib/brand'

import { getOriginalImageById } from 'utils/files'

export const genStops = (from?: string | null, to?: string | null) => [
  { color: from || setThemeVariable('primaryBackgroundColor'), position: 0 },
  { color: to || setThemeVariable('darkBackgroundColor'), position: 100 },
]

const DEFAULT_GRADIENT_STOPS = [
  { color: setThemeVariable('primaryBackgroundColor'), position: 0 },
  { color: setThemeVariable('darkBackgroundColor'), position: 100 },
]
export const DEFAULT_GRADIENT = {
  type: 'linear',
  stops: DEFAULT_GRADIENT_STOPS,
  angle: 90,
  position: [50, 50],
} satisfies GradientValueType

// export const safeParseGradient = (value?: string | null): GradientValueType | null => {
//   try {
//     return value ? JSON.parse(value) : null
//   } catch {
//     return null
//   }
// }

export const applyGradient = (gradient?: GradientValueType | null): string | undefined => {
  if (!gradient) {
    return undefined
  }
  const value = gradient

  if (!value) {
    return undefined
  }
  const { type, angle, position, stops } = value
  const [x, y] = position || [50, 50]

  if (type === 'linear') {
    return `linear-gradient(${angle}deg, ${stops
      .slice()
      .sort((a, b) => a.position - b.position)
      .map((stop) => `${stop.color} ${stop.position}%`)
      .join(', ')})`
  }
  if (type === 'radial') {
    return `radial-gradient(at ${x}% ${y}%, ${stops
      .slice()
      .sort((a, b) => a.position - b.position)
      .map((stop) => `${stop.color} ${stop.position}%`)
      .join(', ')})`
  }
  if (type === 'conic') {
    return `conic-gradient(from ${angle}deg at ${x}% ${y}%, ${stops
      .slice()
      .sort((a, b) => a.position - b.position)
      .map((stop) => `${stop.color} ${stop.position}%`)
      .join(', ')})`
  }
  return undefined
}

export const applyImage = (image?: ImageValueType | null): string | undefined => {
  if (!image) {
    return undefined
  }
  const value = image

  if (!value) {
    return undefined
  }
  const { id, position = 'center', fit = 'cover' } = image
  const size = fit === 'fill' ? '100% 100%' : fit
  const file = getOriginalImageById(String(id))
  return `url('${file?.path}') ${position} / ${size} no-repeat`
}

export const applyBlendMode = (value?: string | null): string => {
  const backgrounds = safeParseBackground(value)
  if (!backgrounds || backgrounds.length === 0) {
    return 'normal'
  }

  return backgrounds
    .filter((item) => !item.data.hide)
    .map((item) => item.data.blendMode || 'normal')
    .join(', ')
}

export const applyBackground = (value?: string | null): string => {
  const backgrounds = safeParseBackground(value)
  if (!backgrounds || backgrounds.length === 0) {
    return 'none'
  }

  const layers = backgrounds
    .filter((item) => !item.data.hide)
    .map((item) => {
      const { type: bgType, color, image, gradient } = item.data

      if (bgType === 'image' && image) {
        return applyImage(image)
      }

      if (bgType === 'gradient' && gradient) {
        return applyGradient(gradient)
      }

      if (bgType === 'color' && color) {
        return `linear-gradient(0deg, ${color}, ${color})`
      }

      return null
    })
    .filter((layer): layer is string => Boolean(layer))

  if (layers.length === 0) {
    return 'none'
  }

  return layers.join(', ')
}
